/**
 * ApiService by karora on 22/03/17.
 */
import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import {Observable, ReplaySubject, Subject} from 'rxjs';

import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { StandardResponse } from '../types/standard-response';
import { throwError } from 'rxjs/internal/observable/throwError';
import {Router} from '@angular/router';

@Injectable()
export class ApiService implements OnInit {
  private static baseHeaders = new HttpHeaders();

  public static RequestHeaders(): HttpHeaders {
    ApiService.baseHeaders.set('API-Key', '4efde62b-db49-475f-9967-71d3dc7cce50');
    return ApiService.baseHeaders;
  }

  constructor(
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    try {
      console.log('OnInit...');
    } catch (e) {
      console.log(e);
    }
  }

  Put(endpoint: string, body: string): Observable<StandardResponse> {
    //console.log("Put: " + endpoint);
    let url = window['apiBaseURL'] + endpoint;
    let observer: Subject<StandardResponse> = new Subject<StandardResponse>();
    try {
      this.http.put(url, body, { headers: ApiService.RequestHeaders() })
        .subscribe(
          function (v: Object) {
          observer.next(v as StandardResponse);
        }, observer.error
        );
    } catch (e) {
      console.log('Put: error: ' + e);
    }
    //console.log('returning from pust....');
    return observer.asObservable();
  }

  Get(endpoint: string, hash: string): Observable<StandardResponse> {
    let url = window['apiBaseURL'] + endpoint + hash;
    console.log(url)
    let observer: Subject<StandardResponse> = new Subject<StandardResponse>();
    try {
      this.http.get(url, { headers: ApiService.RequestHeaders() })
        .subscribe(
          function (v: Object) {
          observer.next(v as StandardResponse);
        }, observer.error

        
        );
    } catch (e) {
      console.log('Get2: error: ' + e);
    }
    return observer.asObservable();
  }
}
